export const HELLO = 'hello.atlassian.net';
export const PUG = 'pug.jira-dev.com';
export const LOCAL = 'localhost';
